/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor } from './IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor';
import {
    IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorFromJSON,
    IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorFromJSONTyped,
    IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorToJSON,
} from './IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor';

/**
 * 
 * @export
 * @interface IntegrationEventPccPatientLeadsInnerInsurancesInner
 */
export interface IntegrationEventPccPatientLeadsInnerInsurancesInner {
    /**
     * 
     * @type {string}
     * @memberof IntegrationEventPccPatientLeadsInnerInsurancesInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEventPccPatientLeadsInnerInsurancesInner
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEventPccPatientLeadsInnerInsurancesInner
     */
    payor_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEventPccPatientLeadsInnerInsurancesInner
     */
    unmatched_payor_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEventPccPatientLeadsInnerInsurancesInner
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationEventPccPatientLeadsInnerInsurancesInner
     */
    coverage_priority?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationEventPccPatientLeadsInnerInsurancesInner
     */
    is_active_payer?: boolean;
    /**
     * 
     * @type {IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor}
     * @memberof IntegrationEventPccPatientLeadsInnerInsurancesInner
     */
    payor?: IntegrationEventPccPatientLeadsInnerInsurancesInnerPayor;
}

/**
 * Check if a given object implements the IntegrationEventPccPatientLeadsInnerInsurancesInner interface.
 */
export function instanceOfIntegrationEventPccPatientLeadsInnerInsurancesInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IntegrationEventPccPatientLeadsInnerInsurancesInnerFromJSON(json: any): IntegrationEventPccPatientLeadsInnerInsurancesInner {
    return IntegrationEventPccPatientLeadsInnerInsurancesInnerFromJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerInsurancesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventPccPatientLeadsInnerInsurancesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'payor_id': !exists(json, 'payor_id') ? undefined : json['payor_id'],
        'unmatched_payor_name': !exists(json, 'unmatched_payor_name') ? undefined : json['unmatched_payor_name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'coverage_priority': !exists(json, 'coverage_priority') ? undefined : json['coverage_priority'],
        'is_active_payer': !exists(json, 'is_active_payer') ? undefined : json['is_active_payer'],
        'payor': !exists(json, 'payor') ? undefined : IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorFromJSON(json['payor']),
    };
}

export function IntegrationEventPccPatientLeadsInnerInsurancesInnerToJSON(value?: IntegrationEventPccPatientLeadsInnerInsurancesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'payor_id': value.payor_id,
        'unmatched_payor_name': value.unmatched_payor_name,
        'type': value.type,
        'coverage_priority': value.coverage_priority,
        'is_active_payer': value.is_active_payer,
        'payor': IntegrationEventPccPatientLeadsInnerInsurancesInnerPayorToJSON(value.payor),
    };
}

